import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import ProtectedRoute from './ProtectedRoute';

import { pathIsAllowed } from '../../reducers/auth-reducer';

const mapStateToProps = (state, ownProps) => ({
  loggedIn: state.auth.loggedIn,
  redirectTo: ownProps.redirectPath,
  blocked: !pathIsAllowed(ownProps.path, state) // withRouter passes down the route's path via ownProps
});

export default withRouter(connect(mapStateToProps)(ProtectedRoute));
